


























import { Component, Vue, Prop } from 'vue-property-decorator';

export interface UploadForm {
  id: string;
  label: string;
  value: string;
  error: string | boolean;
}

@Component({
  components: {},
})
export default class UploadQuestionForm extends Vue {
  @Prop()
  forms!: UploadForm[];
}
